module.exports = __webpack_public_path__ + "static/media/mongolia_no_limits_1.c551abc8.jpg";